import React, { FC, useState } from 'react';

import { AuthContext } from './AuthContext';
// import { ACCESS_TOKEN } from '@app/constants/storage';

export const AuthProvider: FC = ({ children }) => {
  const [openLogin, setOpenLogin] = useState(false);

  const setOpenLoginContext = (val: boolean) => {
    setOpenLogin(val);
  };

  return (
    <AuthContext.Provider
      value={{
        openLogin,
        setOpenLogin: setOpenLoginContext,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
